import type { FormControl } from '@angular/forms';

import { SLUG_PATTERN } from '../regex-patterns';

export function slugValidator(control: FormControl<string>): { slugPattern: boolean } | null {
  return SLUG_PATTERN.test(control.value) ? null : { slugPattern: true };
}
